import React, { FunctionComponent, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom"
import { RelatedProductsContainer, RelatedProductTitlePage, RelatedProductsScroll, RelatedProductsShimmerContainer, RelatedProductsShimmerWrapper, RelatedProductsShimmerImageCard, RelatedProductsShimmerDescriptionCardContainer, RelatedProductsShimmerDescriptionCard } from './style';
import { RootState } from '../../redux/reducers';
import ProductCard from '../ProductCard';
import { useSelector, useDispatch } from 'react-redux';
import { language } from '../../utils/language';
import { DataService } from '../../utils/dataService'
import config, { path } from '../../config/enviroment'
import RelatedProductLoader from './relatedProductLoader';
import { setRelatedProducts } from '../../redux/actions/productAction'
import axios from 'axios';
import { datadogLogs } from '@datadog/browser-logs';

type ProductType = {
    id: number,
    title: string,
    netAmount: number,
    amount: number,
    discountPrice: number,
    discountRate: number,
    img: string[],
}

type RelatedProductProps = {
    idCategory?: number,
    isOnModal?: boolean
}


const RelatedProducts: FunctionComponent<RelatedProductProps> = ({ isOnModal = false }) => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);
    const history = useHistory()
    const [products, setProducts] = useState<RelatedProductProps[]>([]);
    const { idCategory, idProduct } = useParams<{ idCategory: string; idProduct: string }>();
    const dispatch = useDispatch();
    const relatedProducts = useSelector((state: RootState) => state.product.relatedProducts);

    useEffect(() => {

        const source = axios.CancelToken.source();
        if (!isOnModal) {
            const _dataService = new DataService();

            try {
                _dataService
                    .post("/v2/catalogue/products/related",
                        {
                            url: path,
                            id: parseInt(idProduct),
                            categoryId: parseInt(idCategory),
                            filter: {
                                origin: "epayco",
                            },
                        },
                        source.token
                    ).then((response) => {

                        let mappedProducts = response.data.data.map((value: any) => {

                            return {
                                id: value.id,
                                title: value.title,
                                netAmount: value.netAmount,
                                amount: value.amount,
                                discountPrice: value.discountPrice,
                                discountRate: value.discountRate,
                                img: [value.img],
                            }

                        });
                        setProducts((mappedProducts.length) ? mappedProducts : null);
                        dispatch(setRelatedProducts(mappedProducts));

                    })
                    .catch((error) => {
                        if (axios.isCancel(error)) {
                            return;
                        }

                        datadogLogs.logger.info('error request relatedProducts', {
                            name: 'post /v2/catalogue/products/related',
                            error: (error as Error).message,
                        });
                    })
            } catch (error) {

            }

        } else {
            setProducts((relatedProducts.length) ? relatedProducts : null);


        }
        return () => {
            source.cancel("Request canceled by user");


        };
    }, [isOnModal, idProduct, idCategory]);


    const handleRedirectProductInfo = (idProduct: number) => {
        history.push(`/vende/${homeState.catalogueUrlName}/product-info/${idCategory}/${idProduct}`)
    }

    return (




        products && products.length === 0 ?
            <div>
                <RelatedProductTitlePage color={homeState.color}>{language[homeState.default_language]["relatedProduct"]}</RelatedProductTitlePage>
                <RelatedProductLoader />
            </div>
            :
            <>
                {products && products.length > 0 &&

                    <RelatedProductsContainer>
                        <RelatedProductTitlePage color={homeState.color}>{language[homeState.default_language]["relatedProduct"]}</RelatedProductTitlePage>
                        <RelatedProductsScroll>
                            {
                                products.map((product, index) => {
                                    if (index === 4 && !isOnModal) return <></>;
                                    return <ProductCard key={product.id} isOnModal={isOnModal} product={product} minWidth={(isOnModal && products.length === 5) ? '17%' : '25%'} imageContainerWidth={isOnModal ? '20vh' : '30vh'} handleRedirectProductInfo={handleRedirectProductInfo} />
                                })
                            }
                        </RelatedProductsScroll>
                    </RelatedProductsContainer>
                }
            </>




    )
}

export default RelatedProducts
